<script>
import {
    eventGroupState,
    isSelectedEventGroupLocked
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    commitHistory
} from '@app/store/historyStore.svelte.js';
import removeEvent from '@cclib/functions/eventGroups/removeEvent.js';
import { current } from 'immer';
import { toast } from "@zerodevx/svelte-toast";
import * as m from '@app/paraglide/messages.js';

let isDisabled = $derived(!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0 || isSelectedEventGroupLocked());

function removeEvents() {
    if (isSelectedEventGroupLocked()) {
        toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
        return;
    }

    const egIdx = projectState.selected;
    const selected = [...eventGroupState[egIdx].selected].sort((a, b) => b - a);
    const lastEvent = selected[selected.length - 1] - 1;

    commitHistory({
        name: "remove event(s)",
        eventGroup: egIdx,
        mutate: {
            eventGroupState: (draft) => {
                selected.forEach((eventIndex) => {
                    draft[egIdx] = removeEvent(current(draft[egIdx]), eventIndex);
                });
                draft[egIdx].selected = lastEvent >= 0 ? [lastEvent] : [];
            },
        },
    });

    // Dispatch custom event to scroll to the selected event if one exists
    if (eventGroupState[egIdx].selected[0] !== undefined) {
        const selectedIndex = eventGroupState[egIdx].selected[0];
        window.dispatchEvent(new CustomEvent('scrollToVirtualListItem', {
            detail: { index: selectedIndex }
        }));
    }
}
</script>
<li 
    title={m.remove_event_title()}
    class="nav-item"
    role="none"
    class:disabled={isDisabled}>
    <a class="nav-link"
       href="#!/"
       role="button"
       id="remove-events-btn"
       aria-label={m.remove_event_aria_label()}
       aria-disabled={isDisabled}
       onclick={removeEvents}>
        <i class="bi bi-trash" aria-hidden="true"></i>
    </a>
</li>
